import { render, staticRenderFns } from "./pageUICustom.vue?vue&type=template&id=c9eaded2&scoped=true&"
import script from "./pageUICustom.vue?vue&type=script&lang=js&"
export * from "./pageUICustom.vue?vue&type=script&lang=js&"
import style0 from "./pageUICustom.vue?vue&type=style&index=0&id=c9eaded2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9eaded2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9eaded2')) {
      api.createRecord('c9eaded2', component.options)
    } else {
      api.reload('c9eaded2', component.options)
    }
    module.hot.accept("./pageUICustom.vue?vue&type=template&id=c9eaded2&scoped=true&", function () {
      api.rerender('c9eaded2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/pageUICustom.vue"
export default component.exports